import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#0E0F11] text-[#FAF9F5] pt-20 pb-10">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="grid md:grid-cols-12 gap-12 pb-14 border-b border-[#FAF9F5]/10">
        <div className="md:col-span-6">
          <p className="font-display text-3xl tracking-tight">PrimeConnect</p>
          <p className="text-sm text-[#FAF9F5]/50 leading-relaxed mt-4 max-w-xs">
            The private network for prime residential sales &amp; lettings agents.
            Post, match, and split commission — discreetly.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-eyebrow text-[10px] text-[#B89B6C] mb-5">Legal</p>
          <div className="flex flex-col gap-3">
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="text-sm text-[#FAF9F5]/55 hover:text-[#FAF9F5] transition-colors duration-300"
            >
              Terms of Service
            </Link>
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="text-sm text-[#FAF9F5]/55 hover:text-[#FAF9F5] transition-colors duration-300"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="font-eyebrow text-[10px] text-[#B89B6C] mb-5">Contact</p>
          <div className="flex flex-col gap-3">
            <a
              href="mailto:hello@primeconnect.network"
              data-testid="footer-contact-email"
              className="text-sm text-[#FAF9F5]/55 hover:text-[#FAF9F5] transition-colors duration-300 break-all"
            >
              hello@primeconnect.network
            </a>
          </div>
        </div>
      </div>
      <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-eyebrow text-[9px] text-[#FAF9F5]/35">
          &copy; Prime Connect Technology LTD
        </p>
        <p className="font-display italic text-sm text-[#FAF9F5]/35">
          The power of network.
        </p>
      </div>
    </div>
  </footer>
);
